import { ButtonSource } from '@/constants/buttonSources';
import { VITE_APP_ENV } from '@/constants/constants';

interface ButtonClickParams {
  buttonId: string;
  buttonName: string;
  buttonSource: ButtonSource;
  urlParams?: {
    brandId?: string;
    orderId?: string;
    tableNumber?: string;
    counterNumber?: string;
  };
  onTracked?: () => void;
  instantRedirect?: boolean;
  extraParams?: Record<string, string>;
}

const IS_DEBUG_ENABLED = true; // make inpact only on dev & stage env

const debugEvent = (eventName: string, params: Record<string, string>) => {
  if (IS_DEBUG_ENABLED && VITE_APP_ENV !== 'prod') {
    console.debug(eventName);
    console.table(params);
  }
};

export const trackEvent = (eventName: string, params: Record<string, string>) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
    debugEvent(eventName, params);
  }
};

export const trackButtonClick = ({
  buttonId,
  buttonName,
  buttonSource,
  urlParams = {},
  onTracked,
  instantRedirect = false,
  extraParams = {},
}: ButtonClickParams): Promise<void> => {
  const { brandId = '', orderId = '', tableNumber = '', counterNumber = '' } = urlParams;

  const payload = {
    button_id: buttonId,
    button_name: buttonName,
    button_source: buttonSource,
    brand_id: brandId,
    order_id: orderId,
    table_number: tableNumber,
    counter_number: counterNumber,
    ...extraParams,
  };

  debugEvent('button_clicked', payload);

  if (instantRedirect && onTracked) {
    onTracked();

    return new Promise(resolve => {
      if (typeof window.gtag === 'function') {
        try {
          window.gtag('event', 'button_clicked', {
            ...payload,
          });
        } catch (err) {
          console.error('Error tracking button click:', err);
        }
      }
      resolve();
    });
  }

  return new Promise(resolve => {
    if (typeof window.gtag === 'function') {
      try {
        const timeoutId = setTimeout(() => {
          onTracked?.();
          resolve();
        }, 1000);

        window.gtag('event', 'button_clicked', {
          event_callback: () => {
            clearTimeout(timeoutId);
            onTracked?.();
            resolve();
          },
          ...payload,
        });
      } catch (err) {
        console.error('Error tracking button click:', err);
        onTracked?.();
        resolve();
      }
    } else {
      onTracked?.();
      resolve();
    }
  });
};
